import * as S from "./styled";

// Real <img fetchPriority="high"> instead of a CSS background-image so the browser can
// start the request as soon as this mounts, instead of waiting on CSS resolution.
// See: https://web.dev/articles/optimize-lcp#preload_important_resources
// WebP first (24-61% smaller than the equivalent JPEG on these photos), JPEG as the
// <img> fallback for the handful of browsers that don't support WebP.
export const HeroImage = ({ alt = "", image }) => (
  <picture>
    <source srcSet={image.webp} type="image/webp" />
    <S.HeroImage alt={alt} decoding="async" fetchPriority="high" loading="eager" src={image.jpg} />
  </picture>
);
